// import { useState } from 'react'
// import { createContract } from "../../features/contractSlice"
// import { useDispatch, useSelector } from 'react-redux'
// import { useNavigate, Link } from 'react-router-dom'
// import validator from "validator";
// import { AddressAutofill } from '@mapbox/search-js-react';

// import { v4 as uuidv4 } from 'uuid';

// import { workflow_steps_v2, determineAuthorization, determineAuthorizationV2 } from "../../utils/Helper"
// import { inValidDate, duration } from "../../utils/Validations"

// const AddContract = () => {
//     const navigate = useNavigate()
//     const dispatch = useDispatch()

//     const mapbox_access_token = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN

//     const [addressError, setAddressError] = useState(false);
//     const [datesError, setDatesError] = useState(false);

//     const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
//     const { newContractId, agentInfo, stripeSubs, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

//     const initData = {
//         address: '',
//         apartment: '',
//         city: '',
//         state: '',
//         country: 'US',
//         zipcode: '',
//         agent_name: '',
//         agent_email: '',
//         agent_phone: '',
//         buyer_name: '',
//         buyer_email: '',
//         buyer_phone: '',
//         co_buyer_name: '',
//         co_buyer_email: '',
//         co_buyer_phone: '',
//         txn_coordinator_name: '',
//         txn_coordinator_email: '',
//         txn_coordinator_phone: '',
//         seller_name: '',
//         seller_email: '',
//         seller_phone: '',
//         co_seller_name: '',
//         co_seller_email: '',
//         co_seller_phone: '',
//         loan_officer: '',
//         loan_officer_email: '',
//         loan_officer_phone: '',
//         title_company: '',
//         title_company_email: '',
//         title_company_phone: '',
//         contract_acceptance_date: '',
//         closing_date: '',
//         steps: [],
//         contract_status: '',
//         sale_price: 0,
//         createdBy: '',
//         updatedBy: '',
//     }

//     const [data, setData] = useState(initData)

//     const handleInputData = input => e => {
//         const { value } = e.target

//         setData(prevState => ({
//             ...prevState,
//             [input]: value
//         }))
//     }

//     let { freeTrial, active, expDate } = determineAuthorizationV2(role, stripeSubs, agentInfo)

//     const submitFormData = (e) => {
//         e.preventDefault()

//         if (
//             validator.isEmpty(data.address) ||
//             validator.isEmpty(data.city) ||
//             validator.isEmpty(data.state) ||
//             validator.isEmpty(data.zipcode)
//         ) {
//             setAddressError(true)
//         } else if (inValidDate(data.contract_acceptance_date) || inValidDate(data.closing_date) || duration(data.contract_acceptance_date, data.closing_date) < 1) {
//             setAddressError(false)
//             setDatesError(true)
//         } else {
//             if (role === "Agent") {
//                 data.agent_email = email
//             } else if (role === "Transaction Coordinator") {
//                 data.agent_email = agentEmail
//             }
//             data.contract_id = uuidv4()
//             data.agent_email = data.agent_email.toLowerCase()
//             data.buyer_email = data.buyer_email.toLowerCase()
//             data.co_buyer_email = data.co_buyer_email.toLowerCase()
//             data.txn_coordinator_email = data.txn_coordinator_email.toLowerCase()
//             data.seller_email = data.seller_email.toLowerCase()
//             data.co_seller_email = data.co_seller_email.toLowerCase()

//             data.loan_officer_email = data.loan_officer_email.toLowerCase()
//             data.title_company_email = data.title_company_email.toLowerCase()

//             let steps = workflow_steps_v2(data.contract_acceptance_date, data.closing_date)
//             data.steps = steps
//             data.contract_status = "Pending"
//             data.createdBy = email
//             data.updatedBy = email
//             dispatch(createContract({ data, idToken }))
//                 .unwrap()
//                 .then(() => {
//                     navigate(`/contract-details/${data.contract_id}`);
//                 })
//                 .catch((error) => {
//                     console.error('Error creating contract:', error);
//                 });

//         }
//     }

//     return (
//         <div className='min-h-screen'>
//             <div className="container-xl lg:container m-auto px-4 py-6">
//                 <div className='text-2xl text-center font-semibold mb-6 uppercase'>Create Contract</div>
//                 {(active || freeTrial) ? (
//                     <div>
//                         <form onSubmit={submitFormData}>
//                             <div>
//                                 <div className='text-xl text-center font-semibold mb-6'>Address</div>
//                                 <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
//                                     <div className='mb-2'>
//                                         <AddressAutofill accessToken={mapbox_access_token}>
//                                             <input
//                                                 className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                                 name="address"
//                                                 defaultValue={data.address}
//                                                 placeholder="Address"
//                                                 type="text"
//                                                 autoComplete="address"
//                                                 onChange={handleInputData("address")}
//                                             />
//                                         </AddressAutofill>
//                                         {addressError ? (
//                                             <span className='italic text-sm text-red-600'>Address is a required field</span>
//                                         ) : (
//                                             ""
//                                         )}

//                                     </div>
//                                     <div className='mb-2'>
//                                         <input
//                                             className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="apartment"
//                                             placeholder="Apartment number"
//                                             type="text"
//                                             autoComplete="address-line2"
//                                             defaultValue={data.apartment}
//                                             onChange={handleInputData("apartment")}
//                                         />
//                                     </div>

//                                     <div className='mb-2'>
//                                         <input
//                                             className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="city"
//                                             placeholder="City"
//                                             type="text"
//                                             autoComplete="address-level2"
//                                             defaultValue={data.city}
//                                             onChange={handleInputData("city")}
//                                         />
//                                         {addressError ? (
//                                             <span className='italic text-sm text-red-600'>City is a required field</span>
//                                         ) : (
//                                             ""
//                                         )}
//                                     </div>

//                                     <div className='mb-2'>
//                                         <input
//                                             className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="state"
//                                             placeholder="State"
//                                             type="text"
//                                             autoComplete="address-level1"
//                                             defaultValue={data.state}
//                                             onChange={handleInputData("state")}
//                                         />
//                                         {addressError ? (
//                                             <span className='italic text-sm text-red-600'>State is a required field</span>
//                                         ) : (
//                                             ""
//                                         )}
//                                     </div>

//                                     <div className='mb-2'>
//                                         <input
//                                             className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="zipcode"
//                                             placeholder="Zipcode"
//                                             type="text"
//                                             autoComplete="postal-code"
//                                             defaultValue={data.zipcode}
//                                             onChange={handleInputData("zipcode")}
//                                         />
//                                         {addressError ? (
//                                             <span className='italic text-sm text-red-600'>Zipcode is a required field</span>
//                                         ) : (
//                                             ""
//                                         )}
//                                     </div>
//                                 </div>

//                                 <div className='text-xl text-center font-semibold mt-6'>Dates</div>
//                                 <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
//                                     <div className='mb-2'>
//                                         <label className='font-semibold text-xl mt-5'>Acceptance Date</label>
//                                         <input
//                                             className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="contract_acceptance_date"
//                                             type="date"
//                                             onChange={handleInputData("contract_acceptance_date")}
//                                         />
//                                     </div>

//                                     <div className='mb-2'>
//                                         <label className='font-semibold text-xl mt-5'>Closing Date</label>
//                                         <input
//                                             className='block w-full px-4 py-2 mt-2 bg-white border rounded-md focus:border-indigo-400 focus:ring-indigo-300 focus:outline-none focus:ring focus:ring-opacity-40'
//                                             name="closing_date"
//                                             type="date"
//                                             onChange={handleInputData("closing_date")}
//                                         />

//                                     </div>
//                                     {datesError ? (
//                                         <span className='italic text-sm text-red-600 md:col-span-2'>Check the dates. Either dates are empty or Closing date is earlier or equal to Agreement date</span>
//                                     ) : (
//                                         ""
//                                     )}
//                                 </div>
//                             </div>

//                             <div>
//                                 <button className='bg-blue-500 hover:bg-blue-600 text-white font-bold my-4 py-2 px-4 rounded-full w-full focus:outline-none focus:shadow-outline'
//                                     type='submit'>Create Contract</button>
//                             </div>
//                         </form>
//                     </div>
//                 ) : (
//                     <div>
//                         You have not subscribed to Contract To Keys.
//                         <button
//                             className='w-[150px] h-[36px] bg-gray-500 hover:bg-gray-600 text-white rounded-lg text-center text-sm'>
//                             <Link to={"/sub/"}>Subscribe</Link>
//                         </button>
//                     </div>
//                 )}
//             </div>

//             {apiError && <div className='mt-5 italic text-lg text-center'>{apiErrorMessage}</div>}
//         </div>
//     )
// }

// export default AddContract

import { useState } from 'react'
import { createContract } from "../../features/contractSlice"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom'
import validator from "validator";
import { AddressAutofill } from '@mapbox/search-js-react';
import { v4 as uuidv4 } from 'uuid';
import { workflow_steps_v2, determineAuthorizationV2 } from "../../utils/Helper"
import { inValidDate, duration } from "../../utils/Validations"

const AddContract = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const mapbox_access_token = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN

    const [addressError, setAddressError] = useState(false);
    const [datesError, setDatesError] = useState(false);

    const { role, email, idToken, agentEmail } = useSelector((state) => state.auth);
    const { newContractId, agentInfo, stripeSubs, apiError, apiErrorMessage } = useSelector((state) => state.contracts)

    const initData = {
        address: '',
        apartment: '',
        city: '',
        state: '',
        country: 'US',
        zipcode: '',
        agent_name: '',
        agent_email: '',
        agent_phone: '',
        buyer_name: '',
        buyer_email: '',
        buyer_phone: '',
        co_buyer_name: '',
        co_buyer_email: '',
        co_buyer_phone: '',
        txn_coordinator_name: '',
        txn_coordinator_email: '',
        txn_coordinator_phone: '',
        seller_name: '',
        seller_email: '',
        seller_phone: '',
        co_seller_name: '',
        co_seller_email: '',
        co_seller_phone: '',
        loan_officer: '',
        loan_officer_email: '',
        loan_officer_phone: '',
        title_company: '',
        title_company_email: '',
        title_company_phone: '',
        contract_acceptance_date: '',
        closing_date: '',
        steps: [],
        contract_status: '',
        sale_price: 0,
        createdBy: '',
        updatedBy: '',
    }

    const [data, setData] = useState(initData)

    const handleInputData = input => e => {
        const { value } = e.target
        setData(prevState => ({
            ...prevState,
            [input]: value
        }))
    }

    let { freeTrial, active, expDate } = determineAuthorizationV2(role, stripeSubs, agentInfo)

    const submitFormData = (e) => {
        e.preventDefault()

        if (
            validator.isEmpty(data.address) ||
            validator.isEmpty(data.city) ||
            validator.isEmpty(data.state) ||
            validator.isEmpty(data.zipcode)
        ) {
            setAddressError(true)
        } else if (inValidDate(data.contract_acceptance_date) || inValidDate(data.closing_date) || duration(data.contract_acceptance_date, data.closing_date) < 1) {
            setAddressError(false)
            setDatesError(true)
        } else {
            if (role === "Agent") {
                data.agent_email = email
            } else if (role === "Transaction Coordinator") {
                data.agent_email = agentEmail
            }
            data.contract_id = uuidv4()
            data.agent_email = data.agent_email.toLowerCase()
            data.buyer_email = data.buyer_email.toLowerCase()
            data.co_buyer_email = data.co_buyer_email.toLowerCase()
            data.txn_coordinator_email = data.txn_coordinator_email.toLowerCase()
            data.seller_email = data.seller_email.toLowerCase()
            data.co_seller_email = data.co_seller_email.toLowerCase()
            data.loan_officer_email = data.loan_officer_email.toLowerCase()
            data.title_company_email = data.title_company_email.toLowerCase()

            let steps = workflow_steps_v2(data.contract_acceptance_date, data.closing_date)
            data.steps = steps
            data.contract_status = "Pending"
            data.createdBy = email
            data.updatedBy = email
            dispatch(createContract({ data, idToken }))
                .unwrap()
                .then(() => {
                    navigate(`/contract-details/${data.contract_id}`);
                })
                .catch((error) => {
                    console.error('Error creating contract:', error);
                });
        }
    }

    return (
        <div className="bg-gray-50 min-h-screen py-12">
            <div className="max-w-3xl mx-auto px-4">
                <div className="mb-10 text-center">
                    <h1 className="text-3xl font-bold text-gray-900">Create New Contract</h1>
                    <p className="mt-2 text-gray-600">Enter property details to get started</p>
                </div>

                {(active || freeTrial) ? (
                    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                        <form onSubmit={submitFormData}>
                            <div className="p-6">
                                <div className="mb-8">
                                    <div className="flex items-center mb-4">
                                        <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mr-3">1</div>
                                        <h2 className="text-xl font-semibold text-gray-800">Property Address</h2>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="col-span-2">
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Street Address</label>
                                            <AddressAutofill accessToken={mapbox_access_token}>
                                                <input
                                                    className={`block w-full px-4 py-3 bg-white border ${addressError ? 'border-red-300 ring-red-300' : 'border-gray-300'} rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1`}
                                                    name="address"
                                                    defaultValue={data.address}
                                                    placeholder="Enter street address"
                                                    type="text"
                                                    autoComplete="address"
                                                    onChange={handleInputData("address")}
                                                />
                                            </AddressAutofill>
                                            {addressError && (
                                                <p className="mt-1 text-sm text-red-600">Address is required</p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Apartment/Unit (Optional)</label>
                                            <input
                                                className="block w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1"
                                                name="apartment"
                                                placeholder="Apt, Suite, Unit, etc."
                                                type="text"
                                                autoComplete="address-line2"
                                                defaultValue={data.apartment}
                                                onChange={handleInputData("apartment")}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
                                            <input
                                                className={`block w-full px-4 py-3 bg-white border ${addressError ? 'border-red-300 ring-red-300' : 'border-gray-300'} rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1`}
                                                name="city"
                                                placeholder="Enter city"
                                                type="text"
                                                autoComplete="address-level2"
                                                defaultValue={data.city}
                                                onChange={handleInputData("city")}
                                            />
                                            {addressError && (
                                                <p className="mt-1 text-sm text-red-600">City is required</p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
                                            <input
                                                className={`block w-full px-4 py-3 bg-white border ${addressError ? 'border-red-300 ring-red-300' : 'border-gray-300'} rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1`}
                                                name="state"
                                                placeholder="Enter state"
                                                type="text"
                                                autoComplete="address-level1"
                                                defaultValue={data.state}
                                                onChange={handleInputData("state")}
                                            />
                                            {addressError && (
                                                <p className="mt-1 text-sm text-red-600">State is required</p>
                                            )}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">ZIP Code</label>
                                            <input
                                                className={`block w-full px-4 py-3 bg-white border ${addressError ? 'border-red-300 ring-red-300' : 'border-gray-300'} rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1`}
                                                name="zipcode"
                                                placeholder="Enter ZIP code"
                                                type="text"
                                                autoComplete="postal-code"
                                                defaultValue={data.zipcode}
                                                onChange={handleInputData("zipcode")}
                                            />
                                            {addressError && (
                                                <p className="mt-1 text-sm text-red-600">ZIP code is required</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-8">
                                    <div className="flex items-center mb-4">
                                        <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-bold mr-3">2</div>
                                        <h2 className="text-xl font-semibold text-gray-800">Contract Dates</h2>
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Acceptance Date</label>
                                            <input
                                                className={`block w-full px-4 py-3 bg-white border ${datesError ? 'border-red-300 ring-red-300' : 'border-gray-300'} rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1`}
                                                name="contract_acceptance_date"
                                                type="date"
                                                onChange={handleInputData("contract_acceptance_date")}
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Closing Date</label>
                                            <input
                                                className={`block w-full px-4 py-3 bg-white border ${datesError ? 'border-red-300 ring-red-300' : 'border-gray-300'} rounded-lg focus:border-blue-500 focus:ring-blue-500 focus:outline-none focus:ring-1`}
                                                name="closing_date"
                                                type="date"
                                                onChange={handleInputData("closing_date")}
                                            />
                                        </div>
                                    </div>

                                    {datesError && (
                                        <div className="mt-2 p-3 bg-red-50 border-l-4 border-red-400 rounded">
                                            <p className="text-sm text-red-700">
                                                Please check the dates. Both dates are required and closing date must be after acceptance date.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end">
                                <button
                                    type="submit"
                                    className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                    Create Contract
                                </button>
                            </div>
                        </form>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-sm p-8 text-center">
                        <div className="mb-6">
                            <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-800 mb-2">Subscription Required</h2>
                        <p className="text-gray-600 mb-6">You need an active subscription to create contracts.</p>
                        <Link
                            to="/sub/"
                            className="inline-flex items-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            View Subscription Options
                        </Link>
                    </div>
                )}

                {apiError && (
                    <div className="mt-6 p-4 bg-red-50 border-l-4 border-red-400 rounded">
                        <p className="text-sm text-red-700">{apiErrorMessage}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default AddContract
